import { Controller } from "@hotwired/stimulus"

const EXCLUDED_INPUT_TYPES = ["submit", "reset", "button", "image", "hidden", "search"]

export default class FilterBadgeController extends Controller {
  static targets = ["badge"]
  static values = { form: String }

  declare badgeTarget: HTMLElement
  declare hasBadgeTarget: boolean
  declare formValue: string

  connect(): void {
    this.updateCount()
  }

  updateCount(): void {
    if (!this.hasBadgeTarget) return

    const form = document.getElementById(this.formValue)
    const total = form instanceof HTMLFormElement
      ? Array.from(form.elements).reduce((sum, el) => sum + this.activeCount(el), 0)
      : 0

    this.badgeTarget.textContent = String(total)
    this.badgeTarget.classList.toggle("d-none", total === 0)
  }

  private activeCount(el: Element): number {
    if (el instanceof HTMLSelectElement) {
      if (el.dataset.filterBadgeExclude !== undefined) return 0
      if (el.multiple) return Array.from(el.selectedOptions).filter((option) => option.value).length
      return el.value ? 1 : 0
    }
    if (el instanceof HTMLInputElement) {
      if (el.dataset.filterBadgeExclude !== undefined) return 0
      if (EXCLUDED_INPUT_TYPES.includes(el.type)) return 0
      if (el.type === "checkbox" || el.type === "radio") return el.checked ? 1 : 0
      return el.value ? 1 : 0
    }
    return 0
  }
}
